import { useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card } from "@/pages/AppLayout";
import { Input } from "@/components/ui/input";

export default function Settings() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user.name);
  const [pw, setPw] = useState({ current_password: "", new_password: "" });

  const saveName = async () => {
    try { const { data } = await api.patch("/account/profile", { name }); setUser(data); toast.success("Perfil actualizado"); }
    catch (e) { toast.error(formatError(e)); }
  };
  const savePw = async () => {
    try { await api.post("/account/password", pw); setPw({ current_password: "", new_password: "" }); toast.success("Contraseña actualizada"); }
    catch (e) { toast.error(formatError(e)); }
  };

  return (
    <div data-testid="settings-page">
      <PageHeader eyebrow="Cuenta" title="Configuración" />
      <div className="grid lg:grid-cols-2 gap-6 max-w-4xl">
        <Card className="space-y-4">
          <h2 className="text-lg font-medium text-white">Perfil</h2>
          <div className="space-y-2"><label className="text-sm text-slate-400">Correo</label><Input value={user.email} disabled className="bg-[#0A0D14]" /></div>
          <div className="space-y-2"><label className="text-sm text-slate-400">Nombre</label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="settings-name-input" className="bg-[#0A0D14]" /></div>
          <button onClick={saveName} data-testid="settings-save-name-btn" className="px-4 py-2 rounded-lg bg-blue-500 hover:bg-blue-400 text-white text-sm">Guardar</button>
        </Card>
        <Card className="space-y-4">
          <h2 className="text-lg font-medium text-white">Cambiar contraseña</h2>
          <div className="space-y-2"><label className="text-sm text-slate-400">Contraseña actual</label><Input type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="settings-current-password-input" className="bg-[#0A0D14]" /></div>
          <div className="space-y-2"><label className="text-sm text-slate-400">Nueva contraseña (mín. 8)</label><Input type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="settings-new-password-input" className="bg-[#0A0D14]" /></div>
          <button onClick={savePw} data-testid="settings-save-password-btn" className="px-4 py-2 rounded-lg bg-blue-500 hover:bg-blue-400 text-white text-sm">Actualizar contraseña</button>
        </Card>
      </div>
    </div>
  );
}
